import { render, staticRenderFns } from "./RunningTextPage.vue?vue&type=template&id=72da1bb8&scoped=true&"
import script from "./RunningTextPage.vue?vue&type=script&lang=js&"
export * from "./RunningTextPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72da1bb8",
  null
  
)

export default component.exports